// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__14hCo","title":"ClientReferral_title__2Z3Kt","itemText":"ClientReferral_itemText__1XNgk"};